export const CHAT_TYPES = {
  P2P: "P2P",
  ASSISTANT: "ASSISTANT",
  ROUNDTABLE: "ROUNDTABLE",
  JOB_ACTIVITY: "JOB_ACTIVITY",
} as const;
